import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, createUserWithEmailAndPassword } from 'firebase/auth';
import { initFirebase } from '@/lib/firebase';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useNavigate, Link } from 'react-router-dom';

export default function RegisterPage() {
  const [ready, setReady] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const ctx = await initFirebase();
      if (!ctx) return;
      const auth = getAuth();
      const unsub = onAuthStateChanged(auth, (u) => {
        if (u) navigate('/');
        else setReady(true);
      });
      return () => unsub();
    })();
  }, []);

  async function doRegister(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const auth = getAuth();
      if (password.length < 6) { setError('パスワードは6文字以上にしてください'); return; }
      await createUserWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (e: any) {
      setError(e?.message || '新規登録に失敗しました');
    }
  }

  if (!ready) return null;

  return (
    <div className="min-h-screen bg-background grid place-items-center p-4">
      <Card className="w-full max-w-sm p-6 border-0 shadow-card">
        <h1 className="text-xl font-semibold mb-4">新規登録</h1>
        <form className="space-y-3" onSubmit={doRegister}>
          <div className="space-y-1">
            <label className="text-sm">メールアドレス</label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} inputMode="email" autoComplete="email" required />
          </div>
          <div className="space-y-1">
            <label className="text-sm">パスワード</label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" autoComplete="new-password" required />
          </div>
          {error && <div className="text-xs text-red-600">{error}</div>}
          <Button type="submit" className="w-full">登録</Button>
        </form>
        <div className="text-sm text-muted-foreground mt-3">
          すでにアカウントがありますか？ <Link className="text-primary underline" to="/login">ログインへ</Link>
        </div>
      </Card>
    </div>
  );
}

